import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Box from '@quintoandar/cozy-core/Box';
import Typography from '@quintoandar/cozy-core/Typography';
import tokens from '@quintoandar/cozy-theme/tokens/js';
import { FormattedMessage, injectIntl } from 'react-intl';

import { getMessageByIntlKey } from 'components/DynamicForm/getMessageByIntlKey';

import messages from './messages';

export const ConditionDescriptionList = styled.ul`
    list-style: none;
`;
export const ConditionDescriptionListItem = styled.li`
    margin-bottom: ${tokens.alias.spacing.xsmall};
    &:before {
        content: '\\2022';
        color: ${tokens.alias.color.text.interaction.special.default};
        display: inline-block;
        width: 1em;
        font-size: large;
        margin-left: -1em;
    }
`;

export const ConditionDescriptionWrapper = styled(Box)`
    transition: max-height ${
  ({ showContent }) => showContent ? 'ease-in 0.5s' : 'ease-out 0.5s'
};
    overflow: hidden;
    max-height: ${({ showContent }) => showContent ? '600px' : 0};
`;

export const ConditionDescription = ({
  condition,
  intl,
}) => (
  <ConditionDescriptionWrapper ml={4} mt={1} showContent>
    <Box>
      <Typography level="bodyStrong">
        <FormattedMessage {...messages.descriptionTitle} />
      </Typography>
    </Box>
    <ConditionDescriptionList>
      {
        condition.descriptionKeys && condition.descriptionKeys.map((intlKey, index) => (
          <Typography key={index}>
            <ConditionDescriptionListItem>
              {intl.formatMessage(getMessageByIntlKey({ availableMessages: messages, intlKey }))}
            </ConditionDescriptionListItem>
          </Typography>
        ))
      }
    </ConditionDescriptionList>
  </ConditionDescriptionWrapper>
);

ConditionDescription.propTypes = {
  condition: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(ConditionDescription);
